
import { useState } from "react";
import { toast } from "@/components/ui/use-toast";
import { FileItem } from "../types";
import { fileStorage } from "@/utils/fileStorage";

export const useFileEditing = (files: FileItem[], setFiles: React.Dispatch<React.SetStateAction<FileItem[]>>) => {
  const [editingFile, setEditingFile] = useState<{id: number, name: string} | null>(null);
  const [newFileName, setNewFileName] = useState("");

  const startEditingFile = (fileId: number) => {
    const file = files.find(f => f.id === fileId);
    if (file) {
      setEditingFile({ id: file.id, name: file.name });
      setNewFileName(file.name);
    }
  };

  const saveFileNameEdit = () => {
    if (!editingFile) return;
    
    // Update the file name using our fileStorage utility
    fileStorage.updateFile(editingFile.id, { name: newFileName });
    
    setFiles(files.map(file => 
      file.id === editingFile.id 
        ? { ...file, name: newFileName } 
        : file
    ));
    
    toast({
      title: "Επιτυχία",
      description: `Το όνομα του αρχείου άλλαξε σε "${newFileName}"`
    });
    
    setEditingFile(null);
  };

  return {
    editingFile,
    newFileName,
    setNewFileName,
    setEditingFile,
    startEditingFile,
    saveFileNameEdit
  };
};
